import { ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';

import { InfoFieldValue } from './info-field-value.component';

import { NO_DATA_PLACEHOLDER } from '../../../constants';
import { MetricTooltip } from '../metric-tooltip';
import { Typography } from '../typography';
import { MutedContent } from '../muted-content';

export type InfoFieldProps = {
  label: ReactNode;
  value?: string | number | ReactNode;
  noDataMessage?: string;
  disableTypography?: boolean;
  truncate?: boolean;
} & BoxProps;

export const InfoField = ({
  label,
  value: propValue,
  noDataMessage = NO_DATA_PLACEHOLDER,
  disableTypography: propDisableTypography,
  truncate,
  ...restProps
}: InfoFieldProps) => {
  let value = propValue;
  let disableTypography = propDisableTypography;
  if (propValue == null || propValue === '') {
    value = <MutedContent>{noDataMessage}</MutedContent>;
    disableTypography = true;
  }

  return (
    <Box {...restProps}>
      <Typography variant='body2' color='textSecondary' gutterBottom>
        {label}
      </Typography>

      {truncate ? (
        <MetricTooltip title={value}>
          <Box
            component='span'
            sx={{
              maxWidth: '100%',
              minWidth: 0,
              display: 'display-block',
            }}
          >
            <InfoFieldValue value={value} disableTypography={disableTypography} truncate />
          </Box>
        </MetricTooltip>
      ) : (
        <InfoFieldValue value={value} disableTypography={disableTypography} />
      )}
    </Box>
  );
};
